export default function formatForSubmit(type, value) {
  try {
    switch (type) {
      case "Text":
        return !!value ? value : "";
      case "True/False":
        return !!value ? value : false; // default to false
      case "Date":
        return !!value ? new Date(value).toISOString() : null;
      case "Location":
        return !!value ? JSON.stringify(value) : null;
      case "Image":
        return !!value ? JSON.stringify(value) : null;
      case "File":
        return !!value ? JSON.stringify(value) : null;
      default:
        return !!value ? value : "";
    }
  }
  catch (err) {
    return value;
  }
}
